import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  setup: function setup() {
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    getDetail();
    var orgList = ref({});

    function getDetail() {
      return _getDetail.apply(this, arguments);
    }

    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getOrgTree"]();

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                orgList.value = data;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getDetail.apply(this, arguments);
    }

    var handleSubClick = function handleSubClick(item) {
      router.push({
        path: "/detailsOrganize",
        query: {
          orgId: item.organizeId
        }
      });
    };

    return {
      orgList: orgList,
      handleSubClick: handleSubClick
    };
  }
});